import React from "react";
import StickyFooter from "./StickyFooter";
import Footer from "components/footer/Footer";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {}

export default function PageLayout(props: IProps) {
    return <StickyFooter footer={<Footer />} {...props} />;
}
